import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = window.setTimeout(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 60);
      return () => window.clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return <MotionConfig reducedMotion="user" data-id="element-104" data-mp="27j98n2g9axk">
      <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-105" data-mp="gys358ddxigi">
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-navy focus:px-4 focus:py-2 focus:text-white" data-id="element-106" data-mp="h0cvcrc88pb7">
          Skip to content
        </a>
        <Header data-id="element-107" data-mp="3fpbsc9kp5fai" />
        <main id="main" className="flex-1" data-id="element-108" data-mp="3fnqw8fiqhoaj">
          <Outlet data-id="element-109" data-mp="3fmpi226f8lol" />
        </main>
        <Footer data-id="element-110" data-mp="1isylybzt0ggq" />
      </div>
    </MotionConfig>;
}